module.exports = __webpack_public_path__ + "img/zelfdeterminatie.1917dc40.png";